import { useTranslation } from "react-i18next";
import clsx from "clsx";
import { SUPPORTED_LANGUAGES, SupportedLanguage } from "../i18n";

interface LanguageSwitcherProps {
  className?: string;
  variant?: "compact" | "block";
}

export default function LanguageSwitcher({
  className,
  variant = "compact",
}: LanguageSwitcherProps) {
  const { t, i18n } = useTranslation();
  const current = (i18n.resolvedLanguage || i18n.language || "en").split("-")[0];

  function onChange(lng: string): void {
    void i18n.changeLanguage(lng);
  }

  return (
    <label
      className={clsx(
        "flex items-center gap-2 text-sm text-slate-300",
        variant === "block" && "w-full justify-between",
        className
      )}
    >
      <span className="text-xs uppercase tracking-wide text-slate-400">
        {t("language.label")}
      </span>
      <select
        aria-label={t("language.label")}
        value={current}
        onChange={(e) => onChange(e.target.value)}
        className="rounded-md border border-slate-700 bg-slate-900 px-2 py-1 text-sm text-slate-200 focus:border-brand-400 focus:outline-none"
      >
        {SUPPORTED_LANGUAGES.map((code: SupportedLanguage) => (
          <option key={code} value={code}>
            {t(`language.${code}`)}
          </option>
        ))}
      </select>
    </label>
  );
}
